// src/utils/tracking/trackedRoutes.js
export const TRACKED_ROUTES = [
  "/",
  "/sign-in",
  "/sign-up",
  "/services",
  "/how-it-works",
  "/tax",
];